import { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';

const StatBanner = (props) => {
    const [ projectCount, setProjectCount ] = useState(0);
    const [ techCount, setTechCount ] = useState(0);
    const [ locationCount, setLocationCount ] = useState(0);

    useEffect(() => {
        if (props.projects) {
            setProjectCount(props.projects.length);
            const techSet = new Set();
            const locationSet = new Set();
            props.projects.forEach(p => {
                if (p.technology_types) {
                    p.technology_types.forEach(t => techSet.add(t));
                }
                if (p.project_country) {
                    locationSet.add(p.project_country);
                }
            });
            setTechCount(techSet.size);
            setLocationCount(locationSet.size);
        }
    }, [props.projects]);

return(
<Box sx={{ flexGrow: 1 }}>
    <Grid container wrap="nowrap" spacing={2} size={12}>
        <Grid size="grow" textAlign="center" sx={{borderRightWidth: 1, borderRightStyle: 'solid', borderColor: 'black'}}>
            <Typography variant="h3" >{projectCount}</Typography>
            <Typography >Projects</Typography>
        </Grid>
        <Grid size="grow" textAlign="center" sx={{borderRightWidth: 1, borderRightStyle: 'solid', borderColor: 'black'}}>
            <Typography variant="h3" >{techCount}</Typography>
            <Typography >Technologies</Typography>
        </Grid>
        <Grid size="grow" textAlign="center">
            <Typography variant="h3" >{locationCount}</Typography>
            <Typography >Locations</Typography>
        </Grid>
    </Grid>
</Box>
);
}

export default StatBanner;